import type { IPathBaseParam } from "./path";

import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";
import type { IEnrollmentPurchaseDto } from "@api/courses/enrollments/purchase/types";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  IEnrollmentPurchaseDto
>("courses.enrollments.purchase");

export const purchase = {
  ...postApis,
};
